module.exports = __webpack_public_path__ + "img/customer_first_menu_3.c2f720d6.png";